import { GridFilterModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
import CustomStatusFilter from 'components/DataGrid/createColumns/CustomStatusFilter'
import CustomFiltersMenu from 'components/ui/custom-filters-menu-button'
import React, { useMemo, useState } from 'react'
import {
  categoryOptions,
  dealStatusOptions,
  productTypeOptions,
  serviceNameOptions,
  statusFilters,
  subcategoryOptions,
} from './options'

const ProductsFilters = ({
  filterModel,
  onSetFilter,
  isOpen,
  anchorEl,
  onOpenFilters,
  onClose,
}: {
  filterModel: GridFilterModel
  onSetFilter: (fieldName: string, selectedValues: string[]) => void
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenFilters: (event: React.MouseEvent) => void
  onClose: () => void
}) => {
  const [filterServiceName, setFilterServiceName] = useState<string>('')
  const [filterProductType, setFilterProductType] = useState<string>('')
  const [filterStatus, setFilterStatus] = useState<string>('')
  const [filterCategory, setFilterCategory] = useState<string>('')
  const [filterSubcategory, setFilterSubcategory] = useState<string>('')
  const [filterDealStatus, setFilterDealStatus] = useState<string>('')

  const memoizedServiceNameOptions = useMemo(() => serviceNameOptions, [])
  const memoizedProductTypeOptions = useMemo(() => productTypeOptions, [])
  const memoizedStatusFilters = useMemo(() => statusFilters, [])
  const memoizedCategoryOptions = useMemo(() => categoryOptions, [])
  const memoizedSubcategoryOptions = useMemo(() => subcategoryOptions, [])
  const memoizedDealStatusOptions = useMemo(() => dealStatusOptions, [])

  return (
    <>
      <CustomFiltersMenu
        onOpenCustomFilters={onOpenFilters}
        count={filterModel?.items?.length ?? 0}
        badgeColor={'icon.products'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        <CustomStatusFilter
          context={'productName'}
          options={memoizedServiceNameOptions}
          setterFn={setFilterServiceName}
          filterModel={filterModel}
          value={filterServiceName}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'product_type'}
          options={memoizedProductTypeOptions}
          setterFn={setFilterProductType}
          filterModel={filterModel}
          value={filterProductType}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'status'}
          options={memoizedStatusFilters}
          setterFn={setFilterStatus}
          filterModel={filterModel}
          value={filterStatus}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'category'}
          options={memoizedCategoryOptions}
          setterFn={setFilterCategory}
          filterModel={filterModel}
          value={filterCategory}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'subcategory'}
          options={memoizedSubcategoryOptions}
          setterFn={setFilterSubcategory}
          filterModel={filterModel}
          value={filterSubcategory}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'dealStatus'}
          options={memoizedDealStatusOptions}
          setterFn={setFilterDealStatus}
          filterModel={filterModel}
          value={filterDealStatus}
          onChange={onSetFilter}
        />
        {/* <Divider sx={{ my: 1 }} /> */}
        {/* <CustomDateRangeFilter context="startDate" filterModel={filterModel} onSetDateFilter={onSetDateFilter} />
        <CustomDateRangeFilter context="endDate" filterModel={filterModel} onSetDateFilter={onSetDateFilter} /> */}
      </CustomFiltersModal>
    </>
  )
}
export default ProductsFilters
